class Location {
    constructor() {
        let map = null;

        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("detail_location", () => ({
                    LOADING: 1,
                    ERROR: 2,
                    status: null,

                    index: 0,

                    location: {},

                    dialogMap: null,
                    dialogItinerary: null,

                    async init() {
                        window.alpineRender(this);
                        const map = document.querySelector("#imgMap");
                        if (!map.complete) {
                            this.status = this.LOADING;
                        }

                        this.dialogMap =
                            document.querySelector(`[x-ref='dialogLoc']`);
                        this.dialogItinerary = document.querySelector(
                            `[x-ref='dialogItinerary']`,
                        );
                    },

                    openDialogMap() {
                        if (!this.dialogMap.open) {
                            this.dialogMap.showModal();
                        }
                        this.render();
                    },
                    closeDialogMap() {
                        if (this.dialogMap.open) {
                            this.dialogMap.close();
                            map.remove();
                            map = null;
                        }
                    },
                    closeDialogItinerary(map = false) {
                        if (map) {
                            this.closeDialogMap();
                        }

                        if (this.dialogItinerary.open) {
                            this.dialogItinerary.close();
                        }
                    },
                    render() {
                        if (!map) {
                            map = L.map("map-leaflet", {
                                attributionControl: false,
                                zoomSnap: 0.1,
                                maxBoundsViscosity: 0.9,
                            });

                            const myAttrControl = L.control
                                .attribution()
                                .addTo(map);
                            myAttrControl.setPrefix(
                                '<a href="https://leafletjs.com/" @click="closeDialogMap()">Leaflet</a>',
                            );

                            L.tileLayer(
                                "https://map.sopheos.com/{z}/{x}/{y}.png",
                                {
                                    maxZoom: 19,
                                    attribution:
                                        '&copy; <a href="http://www.openstreetmap.org/copyright" @click="closeDialogMap()">OpenStreetMap</a>',
                                },
                            ).addTo(map);
                        }

                        this.addMarkers();
                    },

                    addMarkers() {
                        L.Icon.Default.imagePath = "/map/";
                        const marker = L.marker([
                            this.location.lat,
                            this.location.lon,
                        ]).addTo(map);

                        const bounds = marker.getLatLng().toBounds(5000);
                        map.fitBounds(bounds, {
                            maxZoom: 17,
                        });
                        map.setMaxBounds(bounds);
                    },
                }));
            },
            { once: true },
        );
    }
}

new Location();
